import React, { useState, useEffect } from "react";
import "./carechronicles.css";
import { Link } from "react-router-dom";
import { MdOutlineArrowOutward } from "react-icons/md";
import axiosConfig from "../../Service/AxiosConfig";

function CareCronicles() {
  const [blogItems, setBlogItems] = useState([]); 
  const [search, setSearch] = useState("");

 const GetBlogData = async () => {
  try {
    const blogs_response = await axiosConfig.get(`/blogapp/blog/?page_size=20`); 
    const sortedBlogs = blogs_response.data.results
      .sort((a, b) => new Date(b.active_from) - new Date(a.active_from))
      .slice(0, 3);
    setBlogItems(sortedBlogs);
  } catch (error) {
    console.log("Error getting blog data :", error);
  }
};


  useEffect(() => {
    if (!search) {
      GetBlogData();
    }
  }, [search]);

  return (
    <div className="carechronics">
      <h2>Care Chronicles</h2>
      <p>Because Care Starts With Knowing</p>
      <div className="care-grid">
        {blogItems.map((ele) => (
          <Link to={`/${ele.slug}`} key={ele.id} className="care-card">
            <img
              src={ele.image?.image || "https://via.placeholder.com/150"}
              alt={ele.title}
            />
            <p>{ele.title}</p>  
            <span className="view-more">
            <hr />
              View More <MdOutlineArrowOutward size={18} />
            </span>
          </Link>

        ))}
      </div>
    </div>
  );
}

export default CareCronicles;
